import React from "react";
import "./PillarsGrid.css";
import mindIcon from "./assets/pillars/mind.png";
import bodyIcon from "./assets/pillars/body.png";
import communityIcon from "./assets/pillars/community.png";
import spiritIcon from "./assets/pillars/spirit.png";

// Each pillar is represented by a real Adinkra symbol rather than an emoji —
// grounded in the collective's actual cultural reference points instead of
// a generic icon set. `bg` is left transparent since each source image
// already carries its own light backdrop; if the icon boxes read too
// small/cropped once you see this live, share PillarsGrid.css and I'll
// size .pillar-card3-icon properly instead of relying on the inline sizing
// below.
export const DEFAULT_PILLARS = [
  {
    key: "mind",
    label: "Mind",
    blurb: "Wellness resources",
    detail:
      "Guided practices, workshops, and resources that support mental clarity and emotional grounding through music.",
    icon: mindIcon,
    iconAlt: "Nyansapo — the wisdom knot",
    bg: "color-mix(in srgb, var(--mihu-pillar-mind, #4A5568) 16%, white)",
  },
  {
    key: "body",
    label: "Body",
    blurb: "Sound & movement",
    detail:
      "Sound baths, rhythm-based movement sessions, and physical practices that use music as a somatic tool.",
    icon: bodyIcon,
    iconAlt: "Nyankopon Adom Nti — by God's grace",
    bg: "color-mix(in srgb, var(--mihu-pillar-body, #D16A4B) 16%, white)",
  },
  {
    key: "community",
    label: "Community",
    blurb: "Events & collective",
    detail:
      "Concerts, festivals, and gatherings that bring artists, healers, and listeners into the same room.",
    icon: communityIcon,
    iconAlt: "Nkonsonkonson — the chain link, unity",
    bg: "color-mix(in srgb, var(--mihu-pillar-community, #2A8F85) 16%, white)",
  },
  {
    key: "spirit",
    label: "Spirit",
    blurb: "Music as ceremony",
    detail:
      "Ceremony, ritual, and reflection — treating a shared song as a practice, not just a performance.",
    icon: spiritIcon,
    iconAlt: "Sankofa — return and get it",
    bg: "color-mix(in srgb, var(--mihu-pillar-spirit, #D9A441) 16%, white)",
  },
];

/**
 * PillarsGrid
 * Props:
 *  - variant: "compact" (icon + label + one-line blurb — Home) |
 *             "detailed" (icon + label + full paragraph — About)
 *  - pillars: override the default 4 (rarely needed)
 */
export default function PillarsGrid({ variant = "compact", pillars = DEFAULT_PILLARS }) {
  return (
    <div className={"pillars-grid" + (variant === "detailed" ? " detailed" : "")}>
      {pillars.map((p) => (
        <div className="pillar-card3" key={p.key} style={{ background: p.bg }}>
          <img className="pillar-card3-bg" src={p.icon} alt="" aria-hidden="true" />
          <div className="pillar-card3-scrim" />
          <div className="pillar-card3-content">
            <div className="pillar-card3-label">{p.label}</div>
            <div className="pillar-card3-text">
              {variant === "detailed" ? p.detail : p.blurb}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
